import { Arrow } from "components/page-components/Icons/small"
import { Link } from "gatsby"
import React from "react"
import { StaticImage } from "gatsby-plugin-image"

export const AusschreibungsdiensteCTA = ({
  searchState,
  close_search_modal,
}) => {
  const { query } = searchState

  const url_query_param = query?.toLowerCase()?.split(" ")?.join("%2520")

  return (
    <Link
      to={`/ausschreibungsdienste${query ? `#q=${url_query_param}` : ""}`}
      className="box columns is-vcentered mx-3 mb-5 is-paddingless"
      onClick={close_search_modal}
    >
      <div className="column is-2 has-text-centered pb-0 pt-4">
        <StaticImage
          src="../../../../images/illustrations/general/looking-for-tenders.png"
          alt=""
          placeholder="blurred"
          layout="constrained"
          formats={["auto", "avif"]}
          width={120}
        />
      </div>
      <div className="column pb-0 px-5">
        <p className="title is-5 has-text-mitternachtsblau">
          Sie suchen nach Ausschreibungen? <br />
          Jetzt nach Frist, Bundesland, Art und vielem mehr filtern
        </p>
      </div>
      <div className="column is-narrow pb-0 pr-4 pt-5 has-text-centered">
        <Arrow {...{ direction: "right", size: 0.8 }} />
      </div>
    </Link>
  )
}
